import { ca } from '@cian/analytics';

import { type IDeveloperAwardsForCardSchema } from 'shared/repositories/special-promos/entities/developer_awards_for_card/DeveloperAwardsForCardSchema';

/**
 * @description Событие: блок наград попал в зону видимости.
 */
export function trackShowAwardsBlock(awards: IDeveloperAwardsForCardSchema): void {
  ca('eventSite', {
    action: 'show_awards',
    category: 'Promo',
    name: 'oldevent',
    products: awards.awards.map((award, index) => ({
      id: award.title,
      offerType: 'title',
      position: index,
    })),
  });
}
